/* eslint-disable no-underscore-dangle */
import { handleFetchResponse } from 'admin/utils';
import { throwOnError } from './utils';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
    current: number;
  };
};

type CampaignResponse = {
  bear_point_shop_name: string;
  bear_point_shop_uuid: string;
  budget_caps_amount: number | null;
  max_total_point_amount: number | null;
  max_point_amount: number | null;
  budget_current_amount: number | null;
  budget_current_time: string | null;
  description: string;
  ends_at: string;
  id: string;
  is_disabled: boolean;
  is_exclusive: boolean;
  is_limit_shop_campaign: boolean;
  name: string;
  organization: {
    code: string;
    name: string;
  };
  point_calculation_rule: string;
  point_calculation_rule_object: string;
  point_expires_at: string | null;
  point_expires_in_days: number | null;
  priority: number;
  private_money: {
    id: string;
    name: string;
  };
  shops: {
    id: string;
    name: string;
  }[];
  blacklisted_shops: {
    id: string;
    name: string;
  }[];
  shop_labels:
    | {
        id: string;
        name_en: string;
        name_ja: string;
        is_active: boolean;
        user_tag_group: {
          id: string;
          name_en: string;
          name_ja: string;
          max_selections: number;
          is_active: boolean;
        };
        user_tag_subgroup: {
          id: string;
          name_en: string;
          name_ja: string;
        } | null;
      }[]
    | null;
  starts_at: string;
  status: string;
  type: string;
};

type CampaignsResponse = Paginated<CampaignResponse>;

export const fetchCampaign = (id: string, query = '') =>
  fetch(`/api/campaigns/${id}?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<CampaignResponse>);

export const fetchCampaignSummary = (id: string, query = '') =>
  fetch(`/api/campaigns/${id}/summary?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then((response) => response.json());

export const fetchCampaigns = (query = '') =>
  fetch(`/api/campaigns?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<CampaignsResponse>);

export const updateCampaign = (id: string, updated: Record<string, unknown> = {}) =>
  fetch(`/api/v2/campaigns/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...updated }),
  })
    .then(handleFetchResponse)
    .then(throwOnError<CampaignResponse>);

export const createCampaign = (params: Record<string, unknown> = {}) =>
  fetch('/api/v2/campaigns', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...params }),
  }).then(throwOnError);
